import React, { useState, useEffect } from 'react';

const StepOne = ({ onStepOneDataChange, formData = {} }) => {
  const [projectName, setProjectName] = useState(formData.projectName || '');
  const [projectId, setProjectId] = useState(formData.projectId || '');
  const [spvName, setSpvName] = useState(formData.spvName || '');

  localStorage.setItem('projectId', projectId);

  useEffect(() => {
    // Update parent component when form data changes
    onStepOneDataChange({ projectName, projectId, spvName });
  }, [projectName, projectId, spvName, onStepOneDataChange]);

  return (
    <div className='p-4'>
      <h2 className="text-lg font-semibold mb-4">Step 1: Project Details</h2>
      <div className='grid grid-cols-3 gap-4'>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Project Name</label>
          <input
            type="text"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
            className="border border-gray-300 rounded p-2 w-full"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">SPV Name</label>
          <input
            type="text"
            value={spvName}
            onChange={(e) => setSpvName(e.target.value)}
            className="border border-gray-300 rounded p-2 w-full"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Project ID (Input from Re-GIST)</label>
          <input
            type="number"
            value={projectId}
            onChange={(e) => setProjectId(e.target.value)}
            className="border border-gray-300 rounded p-2 w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default StepOne;
